import createHistory from 'history/createMemoryHistory';

export class History {
    constructor() {
        this.history = createHistory();
    }

    get location() {
        return this.history.location;
    }

    listen(cb) {
        return this.history.listen(cb);
    }

    push(...args) {
        return this.history.push(...args);
    }

    replace(...args) {
        return this.history.replace(...args);
    }
}

const parseNumber = maybeNumber => {
    const x = Number(maybeNumber);
    if (Number.isNaN(x)) {
        return maybeNumber;
    }
    return x;
};

export const parseQuery = query => {
    if (query === '') {
        return new Map();
    }
    return query
        .slice(1)
        .split('&')
        .map(item => item.split('='))
        .reduce((acc, [key, value]) => {
            acc.set(key, parseNumber(value));
            return acc;
        }, new Map());
};

export const toQuery = map =>
    Array.from(map)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');

export const history = new History();
